import { PAGE_WIDTH_PX } from "./resumeData";

// Renders the given DOM element to an A4 PDF entirely in the browser and
// triggers the download. No network request, no object URLs to clean up.
export async function generateResumePdf(element, fileName) {
  const { default: html2pdf } = await import("html2pdf.js");

  // Make sure web fonts (Poppins for Template 6) are ready before rendering.
  if (document.fonts && document.fonts.ready) await document.fonts.ready;

  await html2pdf()
    .set({
      margin: [8, 0, 8, 0], // mm: top, left, bottom, right (templates carry their own side padding)
      filename: fileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        scrollX: 0,
        scrollY: 0,
        windowWidth: PAGE_WIDTH_PX,
      },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ["css", "legacy"], avoid: [".rt-avoid"] },
      enableLinks: true,
    })
    .from(element)
    .save();
}